import React from 'react';

const LoadingPlaceholder = (props) => {
  const { className, style } = props;

  return <div className={`placeholder-content ${className !== undefined ? className : ''}`} style={style} />;
};

export default LoadingPlaceholder;
